import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { AnimatedItem } from "../../../../components/ui/animated-item";

export const VisionSection = () => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    return (
        <section className="flex flex-col gap-16 px-4 py-20 md:flex-row md:py-30">
            <motion.div
                initial="inactive"
                whileInView="active"
                viewport={{ amount: 0.8, once: true }}
                className="flex basis-1/2 flex-col py-8"
            >
                <AnimatedItem>
                    <p className="pb-4 font-bold text-accent-flashy text-sm uppercase">Always there for You</p>
                </AnimatedItem>
                <AnimatedItem delay={0.1}>
                    <h2 className="font-bold text-4xl md:text-5xl">Keep More of What You Earn at Scale</h2>
                </AnimatedItem>
                <AnimatedItem delay={0.2}>
                    <p className="mt-6 text-muted-foreground text-xl">
                        Talentir maximizes your earnings by protecting your content with advanced Content ID management.
                        Every use is tracked, and your revenue is fully captured. Nothing gets lost, ever.
                    </p>
                </AnimatedItem>
            </motion.div>
            <div className="flex basis-1/2 items-center justify-center">
                <div className="aspect-video w-full">
                    {mounted && (
                        <iframe
                            width="100%"
                            height="100%"
                            // use source without player controls
                            src="https://www.youtube.com/embed/WQETfzjcDV4?showinfo=0"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded YouTube"
                        />
                    )}
                </div>
            </div>
        </section>
    );
};
